import React from 'react'
import { themeColors } from '../../constants'

// Shared left-hand content for every currency picker row (settlement picker,
// favorites picker, payment dropdown) so the font/format/alignment stay
// identical: [flag] [bold black code] [grey label]. The right-hand control
// (radio / star / check) is supplied by each picker.
const CurrencyRow = ({ flag, code, label }) => (
  <span style={styles.wrap}>
    <span style={styles.flag}>{flag}</span>
    <span style={styles.code}>{code}</span>
    <span style={styles.label}>{label}</span>
  </span>
)

const styles = {
  wrap: { display: 'flex', alignItems: 'center', flex: 1, minWidth: 0, textAlign: 'left' },
  flag: { fontSize: '30px', lineHeight: '40px', paddingRight: '12px', flexShrink: 0 },
  code: { fontSize: '16px', fontWeight: 600, color: themeColors.gray900, paddingRight: '10px', flexShrink: 0 },
  label: { fontSize: '14px', color: themeColors.gray700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
}

export default CurrencyRow
